module.exports = __webpack_public_path__ + "static/media/membio.0aae8550.jpeg";